import React, { useState } from "react";
import { Eye, EyeOff } from "lucide-react";

type ModalInputProps = {
  label?: string;
  placeholder?: string;
  required?: boolean;
  value?: any;
  defaultValue?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  type?: string;
  className?: string;
  name?: string;
  error?: any; // Add error prop
  disabled?: boolean; // Add error prop
  readonly?: boolean; // Add error prop
};

const ModalInput: React.FC<ModalInputProps> = ({
  label,
  placeholder,
  required,
  value,
  onChange,
  type,
  className,
  name,
  error,
  defaultValue,
  disabled,
  readonly,
}) => {
  const [showPassword, setShowPassword] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };

  const isPassword = type === "password";
  const isNumber = type === "number";

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    // Prevent negative sign
    if (isNumber && (e.key === "-" || e.key === "e")) {
      e.preventDefault();
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (isNumber && e.target.value.startsWith("-")) return; // Prevent typing negative
    if (onChange) onChange(e);
  };

  return (
    <div className="mb-4 mt-2 w-full">
      <label className="block font-medium mb-2">
        {label} {required && <span className="text-red-500">*</span>}
      </label>
      <div className="relative">
        <input
          type={isPassword && showPassword ? "text" : type}
          placeholder={placeholder}
          value={value}
          onChange={handleChange}
          onKeyDown={handleKeyDown}
          name={name}
          autoComplete={
            isPassword
              ? "new-password"
              : name?.toLowerCase().includes("email")
              ? "new-email"
              : "off"
          }
          className={`w-full border rounded-md p-2 focus:outline-none focus:ring-1 focus:ring-primary min-h-[60px] ${
            error ? "border-red-500 focus:ring-red-500" : "border-gray-300"
          } ${className}`}
          defaultValue={defaultValue}
          disabled={disabled}
          readOnly={readonly}
        />

        {isPassword && (
          <button
            type="button"
            onClick={togglePasswordVisibility}
            className="absolute inset-y-0 right-3 flex items-center text-gray-600"
          >
            {showPassword ? (
              <EyeOff className="h-5 w-5" />
            ) : (
              <Eye className="h-5 w-5" />
            )}
          </button>
        )}
      </div>
      {error && <p className="text-red-500 text-sm mt-1">{error}</p>}
    </div>
  );
};

export default ModalInput;
